const LOG_PREFIX = "[OCM][Custom] "
let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    resolve(true);
    utils.contentLoaded().then(() => {
      if (window.OCM.pageType !== 'block') {
      	runOutstream(utils)
      }
    })
  });
};


let runOutstream = (utils) => {
  (function (w, d) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }
    var ttag = function () {
      const blocked_url = [
        '/living/tonia-sotiropoulou-elle-diethnes-festival-kinimatografou-venetias/',
        'moda/nona-se-apognosi-ti-back2school-doro-na-pareis-sto-pio-dyskolo-isos-paidi-tou-planiti/',
        'moda/axesouar-individual-brand/',
        'moda/three-industry-trailblazers-talk-balancing-career-with-personal-missions/',
        'living/ergeniki-zoi-glyka-kai-vasana',
        'living/sygkatoikisi-2-skylia',
        'living/lifestyle/family-issues-katharo-spiti-dysonv15',
        'elle.gr/omorfia/la-prairie-skincare-routina-omorfia/',
        'omorfia/la-prairie-skincare-routina-omorfia/',
        'elle.gr/moda/genevieve-majari/',
        'omorfia/clean-beauty/',
        'moda/to-self-expression-mesa-apo-tin-techni/',
        'moda/yamamay-stylish-oikologiki-pnoi/',
        'living/o-dikos-mas-kafes-borei-na-einai-filikos-pros-to-perivallon/',
        'moda/how-to-style/',
        'moda/to-look-tis-imeras/',
        'moda/to-look-tis-imeras-t-shirt/',
        'moda/to-look-tis-evdomadas-to-athlitiko-mou-outfit-echei-sustainable-diathesi/',
        'elle.gr/yperoxo-kormi/afta-einai-ta-6-mystika-gia-apolyti-evexia/',
        'elle.gr/yperoxo-kormi/afto/',
        'moda/afto-to-lefko-poukamiso-einai-all-time-class-chic-3-tropoi-na-to-foreseis-tora/',
        '/moda/black-dress-nivea/',
        '/moda/black-blazer/',
        '/omorfia/to-mono-filtro-pou-tha-chreiasteis-fetos-to-kalokairi/',
        '/omorfia/antigiransi-ligo-prin-kai-ligo-meta-ta-prota-anta-ta-proionta-pou-mas-esosan/',
        '/omorfia/editors-approved-ta-proionta-pou-chreiazesai-afto-to-kalokairi/',
        '/moda/mystiko-black-white-look',
        '/moda/summer-collectibles-by-prigipo-to-elliniko-brand-kosmimaton-gemizei-me-panemorfa-dora-to-kalokairi-mas/',
        '/omorfia/antigiransi-ligo-prin-kai-ligo-meta-ta-prota-anta-ta-proionta-pou-mas-esosan/',
      ];


      for (var z = 0; z < blocked_url.length; z++) {
        if (w.location.href.includes(blocked_url[z])) {
          return;
        }
      }

      if (window.teads.page(126897)[138487] !== undefined) {
        return;
      }

      var inread_placement = 138487;

      if (window.location.href.indexOf('moda/') > -1) {
        inread_placement = 153983;
      }

      var passbacks = [
        {
          value: initBrandStudio,
          probability: 0.45
        },
        {
          value: initPhaistos,
          probability: 0.35
        },
        {
          value: initPPN,
          probability: 0.20
        }
      ];

      w.teads.page(126897).placement(inread_placement, {
        slider: {
          allow_corner_position: false,
          allow_top_position: true
        }, "format": "inread", "slot": {"insertInside": true, "selector": ".articleAdSlotInReadVideo", "minimum": 0}
      }).passback(function () {
        randomizer(passbacks)();
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var s = document.createElement('script');
      s.src = 'https://s8t.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    } else {
      w.teadsscript.addEventListener('load', ttag);
    }
  })(window, document);
}

let randomizer = (values) => {
  var i;
  var pickedValue;
  var randomNr = Math.random();
  var threshold = 0;

  for (i = 0; i < values.length; i++) {
    if (values[i].probability === '*') {
      continue;
    }

    threshold += values[i].probability;
    if (threshold > randomNr) {
      pickedValue = values[i].value;
      break;
    }

    if (!pickedValue) {
      //nothing found based on probability value, so pick element marked with wildcard
      pickedValue = values.filter(function(value) {
        return value.probability === '*'
      }).value;
    }
  }

  return pickedValue;
}

let initPhaistos = () => {
  console.log('initPhaistos')
  var selector = document.querySelector('.articleAdSlotInReadVideo');

  if (selector) {
    var script = window.top.document.createElement('script');
    script.async = true;
    script.src = "//static.adman.gr/adman.js";

    var adman_script = document.createElement('script');
    adman_script.text = 'window.AdmanQueue = window.AdmanQueue|| [];\n' +
      '    AdmanQueue.push(function(){\n' +
      '    		Adman.adunit({id:477,h:"https://x.grxchange.gr",inline:true})\n' +
      '    });'

    selector.append(adman_script);
    selector.append(script);
  }
}

let initBrandStudio = () => {
  console.log('initBrandStudio')
  var selector = document.querySelector('.articleAdSlotInReadVideo');
  if (selector) {
    var s = window.top.document.createElement('script');
    s.defer = true;
    s.async = true;
    s.src = "https://thetamarketplace.com/serve/elleinread";
    selector.append(s);
  }
}

let initPPN = () => {
  console.log('initPPN')
  var selector = document.querySelector('.articleAdSlotInReadVideo');

  if (selector === undefined) {
    return;
  }

  // Smart script
  var scripts = document.getElementsByTagName('script')[0];
  var s = document.createElement('script');
  s.async = true;
  s.src = "https://ced.sascdn.com/tag/3433/smart.js";
  scripts.parentNode.insertBefore(s, scripts);
  // Create div
  var ppn_div = document.createElement('div');
  ppn_div.id = 'sas_80268';
  // Script
  var ppn_script = document.createElement('script');
  ppn_script.text = 'var sas = sas || {};\n' +
    '    sas.cmd = sas.cmd || [];\n' +
    '    sas.cmd.push(\n' +
    '        function () {\n' +
    '            sas.call(\n' +
    '                { siteId: 371892, pageId: 1308025, formatId: 80268, tagId: "sas_80268" },\n' +
    '                { networkId: 3433, domain: "//www8.smartadserver.com" }\n' +
    '            );\n' +
    '        }\n' +
    '    );';
  // Append elements
  selector.append(ppn_div);
  selector.append(ppn_script);
}

module.exports = customCode;